import React from 'react';

export const BarChart2Grey = (): React$Element<'svg'> => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M9 10V5M6 10V2M3 10V7" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
